/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthLoginEndpointRequest
 */
export interface AuthLoginEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointRequest
     */
    otp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointRequest
     */
    newPassword?: string | null;
}

export function AuthLoginEndpointRequestFromJSON(json: any): AuthLoginEndpointRequest {
    return AuthLoginEndpointRequestFromJSONTyped(json, false);
}

export function AuthLoginEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthLoginEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
        'otp': !exists(json, 'otp') ? undefined : json['otp'],
        'newPassword': !exists(json, 'new_password') ? undefined : json['new_password'],
    };
}

export function AuthLoginEndpointRequestToJSON(value?: AuthLoginEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
        'otp': value.otp,
        'new_password': value.newPassword,
    };
}


